<!--EJEMPLO DE USO DEL COMPONENTE


EJEMPLOS NUEVOS:CUANDO ES COLUMNA 
<app-toggle-opciones
  class="toggle-ancho-filtro"
  variante="columna"
  [opciones]="opcionesFiltroPostulacion"
  [seleccion]="filtroPostulacion"
  (seleccionChange)="cambiarFiltroPostulacion($event)">
</app-toggle-opciones>


<app-toggle-opciones
  variante="columna"
  [opciones]="[...]"
  [seleccion]="rango"
  (seleccionChange)="rango = $event">
</app-toggle-opciones>

Y CUANDO ES HORIZONTAL
<app-toggle-opciones
  [opciones]="opcionesVista"
  [(seleccion)]="vista"
  (seleccionChange)="cambiarVista($event)">
</app-toggle-opciones>
-->

<div class="toggle-vista" [class.toggle-vista--columna]="variante === 'columna'" [style.--n]="opciones.length" [style.--indice]="indice">
  <span class="toggle-indicador animar-halo"></span>

  <button
    *ngFor="let opcion of opciones; trackBy: trackByValor"
    type="button"
    class="toggle-vista-btn"
    [class.activo]="opcion.valor === seleccion"
    (click)="seleccionar(opcion)"
  >
    <mat-icon *ngIf="opcion.icono">{{ opcion.icono }}</mat-icon>
    {{ opcion.etiqueta }}
  </button>
</div>